import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { AnimateHeight } from '@adsk/bim360-matrix-react-components';
import { childrenType } from '../constants/proptype-validation';

class AnimateHeightPopUp extends PureComponent {
  render() {
    const { className, isOpen, children } = this.props;
    const popUpClasses = cx('AnimateHeightPopUp', className);

    return (
      <AnimateHeight
        className={popUpClasses}
        isOpen={isOpen}
        height="0px"
        timeout={300}
      >
        {children}
      </AnimateHeight>
    );
  }
}

AnimateHeightPopUp.displayName = 'AnimateHeightPopUp';

AnimateHeightPopUp.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  children: childrenType,
};

export default AnimateHeightPopUp;
